/* AbstractCommand superclass
 * methods:
 * - execute: has no fields to be passed. All parameters to be get into account is to set by means of an implementation constructor
 * - undo: cancel or change system status back if it is possible
 */

class AbstractCommand {
    constructor() {}

    execute() {}
    undo()	{}
}

module.exports = AbstractCommand;



// WEBPACK FOOTER //
// ./js/viscom/viscomjs/base/commands/AbstractCommand.js